"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _function = require("../../utils/function.utils");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Search = /*#__PURE__*/function (_Component) {
  _inherits(Search, _Component);

  var _super = _createSuper(Search);

  function Search() {
    var _this;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_debouncedAutocomplete", (0, _lodash["default"])(_this._autocomplete, 400, false));

    _defineProperty(_assertThisInitialized(_this), "_onInput", function (e) {
      if (_this.state.query !== e.target.value) {
        _this.setState({
          isOpen: !!e.target.value
        });

        _this.setState({
          query: e.target.value
        });

        _this._debouncedAutocomplete();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onSearch", function () {
      (0, _function.callFunction)(_this.props.searchFunction, 'onSearch', {
        query: _this.state.query
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onSearchMobile", function () {
      if (!_this.state.isOpen || !_this.state.query) {
        _this.setState({
          isOpen: !_this.state.isOpen
        });
      } else {
        (0, _function.callFunction)(_this.props.searchFunction, 'onSearch', {
          query: _this.state.query
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (e) {
      if (e.key === 'Enter') {
        _this.state.query && _this._onSearch();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_changeHoverState", function (e) {
      _this.setState({
        inputFocus: e.type === 'focus'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onAutocompleteClick", function (e, val) {
      e.preventDefault();

      _this.setState({
        query: val
      });

      _this._onSearch();
    });

    return _this;
  }

  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        query: this.props.searchQuery || '',
        isOpen: false,
        autocomplete: [],
        inputFocus: false
      });
    }
  }, {
    key: "_autocomplete",
    value: function () {
      var _autocomplete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var autocomplete;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.searchAutocompleteFunction && this.state.query)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return (0, _function.callFunction)(this.props.searchAutocompleteFunction, 'onAutocompleteSearch', {
                  query: this.state.query
                });

              case 3:
                autocomplete = _context.sent;
                this.setState({
                  autocomplete: Array.isArray(autocomplete) ? autocomplete : []
                });
                _context.next = 8;
                break;

              case 7:
                this.setState({
                  autocomplete: []
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _autocomplete() {
        return _autocomplete2.apply(this, arguments);
      }

      return _autocomplete;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var searchPlaceholder = this.props.searchPlaceholder;
      return (0, _preact.h)("div", {
        id: "mtn-header-bottom-search",
        className: "mtn-m-search ".concat(this.state.isOpen ? 'mtn-m-search--open' : '')
      }, (0, _preact.h)("div", {
        className: "a-input"
      }, (0, _preact.h)("input", {
        id: "mtn-header-bottom-search-input",
        onFocus: this._changeHoverState,
        onBlur: this._changeHoverState,
        value: this.state.query,
        onChange: this._onInput,
        onInput: this._onInput,
        placeholder: searchPlaceholder,
        type: "text",
        onKeyDown: this._handleKeyDown
      }), Array.isArray(this.state.autocomplete) && this.state.autocomplete.length ? (0, _preact.h)("div", {
        className: "mtn-m-search__autocomplete m-flyout m-flyout--sm is-open d-flyout--md"
      }, (0, _preact.h)("div", {
        className: "m-flyout__content"
      }, (0, _preact.h)("ul", {
        className: "m-selectable-list m-selectable-list--no-border"
      }, this.state.autocomplete.map(function (auto) {
        return (0, _preact.h)("li", {
          className: "mtn-m-search__autocomplete-item"
        }, (0, _preact.h)("a", {
          onClick: function onClick(e) {
            return _this2._onAutocompleteClick(e, auto.value);
          },
          className: "m-selectable-list__item"
        }, auto.label));
      })))) : null, (0, _preact.h)("button", {
        id: "mtn-header-bottom-search-button",
        onClick: this._onSearch,
        className: "mtn-m-search__button ".concat(this.state.inputFocus ? 'a-button' : 'a-button-outline', " has-icon"),
        "aria-label": "Search"
      }, (0, _preact.h)("span", {
        className: "fa fa-search"
      })), (0, _preact.h)("button", {
        id: "mtn-header-bottom-search-button-mobile",
        "aria-label": "Search",
        className: "mtn-m-search__button--mobile has-icon ".concat(this.state.inputFocus ? 'a-button' : 'a-button-outline'),
        onClick: this._onSearchMobile
      }, (0, _preact.h)("span", {
        className: "fa fa-search"
      }))));
    }
  }]);

  return Search;
}(_preact.Component);

var _default = Search;
exports["default"] = _default;